import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Activity, Cloud, Shield, MapPin, FileCheck, Database, Zap, Headphones } from 'lucide-react';

const credibilityFeatures = [
  { label: 'End-to-End Encryption', icon: Lock },
  { label: '99.99% Uptime', icon: Activity },
  { label: 'Hosted on AWS', icon: Cloud },
  { label: 'Data Residency in Canada', icon: MapPin },
  { label: 'GDPR-Ready', icon: Shield },
  { label: 'Transparent Compliance Audits', icon: FileCheck },
  { label: 'Isolated S3 Buckets', icon: Database },
  { label: 'OpenAI SOC 3 APIs', icon: Zap },
  { label: '24/7 Rapid Incident Response', icon: Headphones },
];

const CredibilityTicker = () => {
  // Create multiple instances of the features for seamless looping
  const allFeatures = [...credibilityFeatures, ...credibilityFeatures];

  return (
    <section className="bg-gradient-to-r from-gray-50 via-blue-50 to-gray-50 py-16 sm:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Eyebrow heading */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-4"
        >
          <span className="text-blue-600 font-semibold text-sm sm:text-base uppercase tracking-wide">
            Where Reliability Meets Compliance
          </span>
        </motion.div>

        {/* Main heading */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-center text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12"
        >
          Proven Security. <span className="text-blue-600">Verified Performance.</span>
        </motion.h2>

        {/* Continuous scrolling ticker */}
        <div className="relative overflow-hidden">
          <motion.div
            className="flex gap-4 sm:gap-6"
            animate={{
              x: [0, -100 * credibilityFeatures.length]
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 30,
                ease: "linear",
              },
            }}
          >
            {allFeatures.map(({ label, icon: Icon }, index) => (
              <div
                key={`${label}-${index}`}
                className="flex-shrink-0"
              >
                <div className="inline-flex items-center px-4 py-3 bg-white border border-gray-200 rounded-full shadow-sm hover:shadow-md transition-shadow duration-200 text-gray-700 text-sm sm:text-base font-medium whitespace-nowrap group">
                  <Icon size={18} className="text-blue-600 mr-2 group-hover:scale-110 transition-transform duration-200" />
                  {label}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CredibilityTicker; 